import { EmailPasswordForm } from '@/components/Views/Login/EmailPasswordForm/EmailPasswordForm';
import { OrLine } from '@/components/Elements/OrLine/OrLine';
import {
  InlineNotification,
  NotificationType,
} from '@spotted-zebra-uk/ui-components';
import { useTranslation } from 'react-i18next';
import { Link } from '@/components/Elements/Link/Link';
import styles from './only-email-password-login.module.scss';

type EmailPasswordFormProps = {
  email: string;
  submitting: boolean;
  handleSignIn: (email: string, password: string) => void;
  restartSigninProcess: () => void;
};

export const OnlyEmailPasswordLogin = ({
  email,
  submitting,
  handleSignIn,
  restartSigninProcess,
}: EmailPasswordFormProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <EmailPasswordForm
        email={email}
        submitting={submitting}
        handleSignIn={handleSignIn}
      />
      <OrLine />

      <InlineNotification notificationType={NotificationType.NEUTRAL}>
        <div className={styles.notificationBody}>
          {t('login.expectSSOSignin')}
          <Link
            text={t('login.restartSigninProcess')}
            onClick={restartSigninProcess}
            data-testid="only-email-password-login__restart-link"
          />
          {t('login.makeSureEmailIsCorrect')}
        </div>
      </InlineNotification>
    </div>
  );
};
